<header class="m-topbar" *ngIf="user">

  <button type="button" class="m-icon-btn m-topbar__menu-btn" (click)="toggleMobileMenu($event)" title="Menü">
    <i class="bx bx-menu"></i>
  </button>

  <!-- Şube seçici -->
  <div class="m-branch" ngbDropdown *ngIf="currentBranch">
    <button type="button" class="m-branch__toggle" ngbDropdownToggle>
      <i class="bx bx-store-alt"></i>
      <span class="m-branch__name">{{ currentBranch.name }}</span>
      <i class="bx bx-chevron-down"></i>
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
      <button type="button" class="dropdown-item" *ngFor="let branch of user.branchList"
              [class.active]="branch.id === currentBranch.id" (click)="changeBranch(branch)">
        {{ branch.name }}
      </button>
    </div>
  </div>

  <!-- Müşteri arama -->
  <form class="m-search" *ngIf="hasUserRole" (submit)="$event.preventDefault()">
    <i class="bx bx-search"></i>
    <input type="text"
           class="form-control"
           name="model"
           [(ngModel)]="model"
           [ngbTypeahead]="search"
           [resultFormatter]="resultFormatCustomer"
           [inputFormatter]="inputFormatCustomer"
           (selectItem)="selectedCustomer($event)"
           placeholder="Müşteri aramak için yazın..." />
  </form>

  <div class="m-topbar__actions">

    <!-- Açık / koyu mod -->
    <button type="button" class="m-icon-btn" (click)="toggleDarkMode()"
            [title]="isDark ? 'Açık moda geç' : 'Koyu moda geç'">
      <i class="bx" [ngClass]="isDark ? 'bx-sun' : 'bx-moon'"></i>
    </button>

    <!-- Bildirim sesi -->
    <button type="button" class="m-icon-btn" (click)="toggleSounds()"
            [title]="playSound ? 'Bildirim sesleri açık' : 'Bildirim sesleri kapalı'">
      <i class="bx" [ngClass]="playSound ? 'bx-bell' : 'bx-bell-off'"></i>
    </button>

    <!-- Yeni İşlem -->
    <div ngbDropdown class="m-newop" placement="bottom-right" *ngIf="quickActions.length">
      <button type="button" class="btn btn-primary m-newop__toggle" ngbDropdownToggle>
        <i class="bx bx-plus"></i>
        <span class="m-newop__label">Yeni İşlem</span>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
        <button type="button" class="dropdown-item" *ngFor="let action of quickActions"
                (click)="runQuickAction(action)">
          <i class="{{ action.icon }} me-2"></i>{{ action.label }}
        </button>
      </div>
    </div>

    <!-- Kullanıcı -->
    <div ngbDropdown class="m-user" placement="bottom-right">
      <button type="button" class="m-user__toggle" ngbDropdownToggle>
        <img class="m-user__avatar" src="assets/images/user.png" alt="Kullanıcı" />
        <span class="m-user__name">
          {{ user.firstName | titlecase }}
          <span *ngIf="user.lastName">{{ user.lastName | titlecase }}</span>
        </span>
        <i class="bx bx-chevron-down"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
        <a class="dropdown-item" routerLink="/user/profile/{{ user.id }}">
          <i class="bx bx-user font-size-16 align-middle me-1"></i> Profil
        </a>
        <div class="dropdown-divider"></div>
        <app-theme-switch variant="menu-item"></app-theme-switch>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
          <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> Çıkış Yap
        </a>
      </div>
    </div>

  </div>
</header>
